import { ApiBaseFront } from "../../front/api-base-front";

type PrintOrderCopyRequest = {
  kijshopCd: string,
  shopOrderId: string,
  copyShopOrderId: string,
  data: {
    shopOrderId: string,
    lastName: string,
    status: string,
    createDate: string,
    lastUpdateDate: string,
    note: string,
  },
};

export class ApiPrintShopOrderCopy extends ApiBaseFront {
  constructor(param: PrintOrderCopyRequest) {
    const {
      kijshopCd,
      shopOrderId,
      ..._param
    } = param;
    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/order/copy`,
      'JSON',
      _param,
    );
  }
}